import TranslationNS from '@/utils/Constants/TranslationNS'

const TICKETING = TranslationNS.TICKETING

/**
 * « Inscriptions » of the athletes (`orders`): status line, money tiles, the products sold, the orders
 * list and its filters, the table (what a row opens, what a selection allows) and the pager. The tiles
 * and products steps drop out for an audience without money (the card reuses OrdersPage). The order
 * drawer and the selection bar only exist after a click, so they are described as entries of the
 * table step.
 */
export const ORDERS_TOUR = {
    id: 'orders',
    version: 1,
    paths: ['orders'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Your registered athletes',
            description:
                'Every registration received, with its payment. The line under the title gives the status and the latest registration.',
        },
        {
            key: 'tiles',
            target: '[data-tour="orders-tiles"]',
            placement: 'bottom',
            title: 'Your figures at a glance',
            description: 'Confirmed registrations, money collected, products sold and the platform fees.',
        },
        {
            key: 'products',
            // the card's title band: one row per product and variant can make the card taller than the screen
            target: '[data-tour="sec-orders-products"]',
            block: ':scope > .org-sec-h',
            placement: 'bottom',
            title: 'Products sold',
            description:
                'How many of each extra product were sold with the registrations, variant by variant, and the revenue they brought.',
        },
        {
            key: 'list',
            // the card's title band, not the card: a list taller than the screen leaves no room for the bubble
            target: '[data-tour="sec-orders-list"]',
            block: ':scope > .org-sec-h',
            placement: 'bottom',
            title: 'The list of registrations',
            description:
                'Click a line to open the registration. The Export button at the top right downloads the list as a spreadsheet, the invoices as PDF or the uploaded files.',
        },
        {
            key: 'status',
            target: '[data-tour="orders-status"]',
            placement: 'bottom',
            title: 'Confirmed or cancelled',
            description: 'These filters show all registrations, only the confirmed ones or only the cancelled ones.',
        },
        {
            key: 'search',
            target: '[data-tour="orders-search"]',
            placement: 'bottom',
            title: 'Find someone quickly',
            description:
                'Search a name or an e-mail, narrow to one category or to orders with or without products. « Reset filters » shows everything again.',
        },
        {
            key: 'table',
            target: '[data-tour="sec-orders-list"] .org-tbl',
            block: 'thead',
            placement: 'bottom',
            title: 'Rows, columns and selection',
            description:
                'Click a column head to sort. Tick rows to act on several at once, click a row to open its details.',
            entries: [
                {
                    label: 'Selection',
                    text: 'ticking rows shows a bar to e-mail them, change their status or category, or export them.',
                },
                { label: 'Order', ns: TICKETING, text: 'number, date, status and promo code of the registration.' },
                { label: 'Buyer', ns: TICKETING, text: 'name, e-mail, phone and billing details.' },
                { label: 'Athletes', ns: TICKETING, text: 'the people registered, their category and club.' },
                { label: 'Payment', ns: TICKETING, text: 'what was paid, the invoice PDF and the Stripe payment.' },
                { label: 'History', ns: TICKETING, text: 'every change made to the registration.' },
                { label: 'Edit', ns: TICKETING, text: 'change the category or the athletes, or cancel and re-book.' },
            ],
        },
        {
            key: 'pager',
            target: '[data-tour="sec-orders-list"] .org-pager',
            placement: 'top',
            title: 'Page by page',
            description:
                'Choose how many rows per page and move between pages. Filters and search apply to the whole list.',
        },
    ],
}

export default ORDERS_TOUR
